import { ScrollModule } from './../../../shared/scroll/scroll.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HallComponent } from './hall.component';
import { RouterModule} from '@angular/router';
import { HallRoutingModule } from './hall.routing.module';
import { MatIconModule } from '@angular/material/icon';
import { CompanyService } from '@shared/services/company/company.service';
import { ChildHallModule } from './child-hall/child-hall.module';
import { CompaniesInfoGQL } from '@shared/services/company/companies-info.gql.service';
import { HallsService } from './halls.service';
import { LanguagesService } from '@shared/services/languages/languages.service';
import { RootCategoriesGQL } from '@shared/services/categories/root-categories.gql.service';
// import { HallHeaderModule } from './hall-header/hall-header.module';
import { CategoryByPathGQL } from '@shared/services/categories/category-by-path.gql.service';
import { RandomCompaniesPageGQL } from '@shared/services/company/random-companies-page.gql.service';
import { FooterComponent } from 'app/layout/components/footer/footer.component';
import { ExpoButtonComponent } from 'app/shared/components/expo-button/expo-button.component';
import { CarouselBannerComponent } from 'app/shared/components/carousel-banner/carousel-banner.component';
import { NewsCarouselComponent } from 'app/layout/components/news-carousel/news-carousel.component';
@NgModule({
    imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    ChildHallModule,
    HallRoutingModule,
    ScrollModule,
    FooterComponent,
    CarouselBannerComponent,
    ExpoButtonComponent,
    HallComponent,
    NewsCarouselComponent
],
    providers: [
        CompanyService,
        CompaniesInfoGQL,
        RootCategoriesGQL,
        LanguagesService,
        HallsService,
        CategoryByPathGQL,
        RandomCompaniesPageGQL,
    ]
})
export class HallModule { }
